import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import theme from './theme/theme';
import AuthProvider from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { WebSocketProvider } from './contexts/WebSocketContext';
import { KeyboardShortcutsProvider } from './contexts/KeyboardShortcutsContext';
import ErrorBoundary from './components/common/ErrorBoundary';
import { queryClient } from './lib/queryClient';
import './i18n'; // Initialize i18n
import './index.css';

// Global error logging (can be connected to Sentry, etc.)
const handleGlobalError = (error: Error, errorInfo: React.ErrorInfo) => {
  console.error('[Global Error]', error);
  console.error('[Component Stack]', errorInfo.componentStack);
  // TODO: Send to error tracking service
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ErrorBoundary onError={handleGlobalError}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <NotificationProvider>
              <AuthProvider>
                <WebSocketProvider>
                  <KeyboardShortcutsProvider>
                    <CssBaseline />
                    <App />
                  </KeyboardShortcutsProvider>
                </WebSocketProvider>
              </AuthProvider>
            </NotificationProvider>
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
